import * as React from 'react'
import '../Datepicker/Datepicker.css'
import { StyledCalendar } from '$views/components/MultipleDatepicker/MultipleDatepicker.style'
import { getCurrentTime } from '$utils/dateFormatter'

interface Props {
  days: Date[]
  updateDays: (day: Date) => void
}

export const MultipleDatepicker: React.FC<Props> = ({ days, updateDays }) => {
  const [actualDays, setDays] = React.useState<Date[]>(days)

  React.useEffect(() => {
    setDays(days)
  }, [days])

  const paintSelected = (view, date) => {
    if (actualDays.length > 0) {
      const auxDays = actualDays.map(day => day.getTime())
      if (auxDays.indexOf(date.getTime()) > -1) {
        if (date.getDate() === 11) {
          return 'eleven-selected'
        }
        if (date.getDate() >= 10) {
          return 'selected'
        }
        return 'small-selected'
      }
      return null
    }
    return null
  }

  return (
    <>
      <StyledCalendar
        tileClassName={({ date, view }) => paintSelected(view, date)}
        onClickDay={day => updateDays(day)}
        minDate={getCurrentTime()}
      />
    </>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/MultipleDatepicker/MultipleDatepicker.tsx